import React from "react";
import { ButtonProps, ButtonRenderProps, ContentSection, ListTable } from "sprint-common-web";

import { AddSystemButton } from "./buttons/AddSystemButton";
import { createSystemListingColumns } from "./createSystemListingColumns";
import { useSystemListing } from "./useSystemListing";
import { useSystemListingFilters } from "./useSystemListingFilters";

export const SystemSection: React.FC = () => {
    const { filters, setSort, setPage, setPageSize } = useSystemListingFilters();
    const { items, totalItems, isLoading } = useSystemListing(filters);

    const columns = createSystemListingColumns();

    const addSystemButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddSystemButton
    };

    return (
        <ContentSection header={"Systems"} buttons={[addSystemButtonProps]}>
            <ListTable
                columns={columns}
                items={items}
                pagination={{
                    page: filters.page,
                    pageSize: filters.pageSize,
                    totalItems,
                    onPageChange: setPage,
                    onPageSizeChange: setPageSize
                }}
                sort={{ by: filters.sortBy, order: filters.sortOrder }}
                onSortChange={setSort}
                isLoading={isLoading}
            />
        </ContentSection>
    );
};
